import React from 'react';

const LteTddIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M6.84961 12.791H8.38477V10.166L8.26172 10.3652L6.84961 12.791Z'
				fill='#7F10C3'
			/>
			<path
				d='M11.4835 20.7323V18.5543H11.7643C12.0103 18.5543 12.1976 18.6392 12.3261 18.809C12.4547 18.9788 12.5189 19.2311 12.5189 19.5659V19.7159C12.5189 20.0523 12.4547 20.3062 12.3261 20.4776C12.1976 20.6474 12.0135 20.7323 11.7739 20.7323H11.4835Z'
				fill='#7F10C3'
			/>
			<path
				d='M14.6351 20.7323V18.5543H14.916C15.1619 18.5543 15.3492 18.6392 15.4777 18.809C15.6063 18.9788 15.6705 19.2311 15.6705 19.5659V19.7159C15.6705 20.0523 15.6063 20.3062 15.4777 20.4776C15.3492 20.6474 15.1651 20.7323 14.9255 20.7323H14.6351Z'
				fill='#7F10C3'
			/>
			<path
				clipRule='evenodd'
				d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM19.2012 15.0703C18.8848 15.4219 18.4219 15.7051 17.8125 15.9199C17.2031 16.1348 16.5352 16.2422 15.8086 16.2422C14.6914 16.2422 13.7988 15.9004 13.1309 15.2168C12.4629 14.5332 12.1055 13.582 12.0586 12.3633L12.0527 11.625C12.0527 10.7852 12.2012 10.0527 12.498 9.42773C12.7949 8.79883 13.2188 8.31641 13.7695 7.98047C14.3242 7.64062 14.9648 7.4707 15.6914 7.4707C16.7539 7.4707 17.5781 7.71484 18.1641 8.20312C18.7539 8.6875 19.0977 9.41211 19.1953 10.377H17.2148C17.1445 9.90039 16.9922 9.56055 16.7578 9.35742C16.5234 9.1543 16.1914 9.05273 15.7617 9.05273C15.2461 9.05273 14.8477 9.27148 14.5664 9.70898C14.2852 10.1465 14.1426 10.7715 14.1387 11.584V12.0996C14.1387 12.9512 14.2832 13.5918 14.5723 14.0215C14.8652 14.4473 15.3242 14.6602 15.9492 14.6602C16.4844 14.6602 16.8828 14.541 17.1445 14.3027V12.9785H15.7148V11.5664H19.2012V15.0703ZM10.3594 12.791H11.2266V14.3145H10.3594V16.125H8.38477V14.3145H5.08594L4.96875 13.1074L8.38477 7.61133V7.59375H10.3594V12.791ZM9.25305 18.5543H10.2933V17.9092H7.39636V18.5543H8.41754V21.375H9.25305V18.5543ZM10.6479 17.9092V21.375H11.7881C12.0881 21.3734 12.3594 21.302 12.6022 21.1608C12.8466 21.0179 13.0355 20.8212 13.1688 20.5704C13.3036 20.3181 13.3711 20.0333 13.3711 19.7159V19.5564C13.3695 19.2422 13.2997 18.9589 13.1616 18.7066C13.0251 18.4527 12.8347 18.2567 12.5903 18.1187C12.3459 17.979 12.0706 17.9092 11.7643 17.9092H10.6479ZM13.7996 17.9092V21.375H14.9398C15.2397 21.3734 15.511 21.302 15.7538 21.1608C15.9982 21.0179 16.1871 20.8212 16.3204 20.5704C16.4553 20.3181 16.5227 20.0333 16.5227 19.7159V19.5564C16.5211 19.2422 16.4513 18.9589 16.3132 18.7066C16.1768 18.4527 15.9863 18.2567 15.7419 18.1187C15.4976 17.979 15.2222 17.9092 14.916 17.9092H13.7996Z'
				fill='#7F10C3'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default LteTddIcon;
